export default __webpack_public_path__ + "static/media/plusButonIcon.fa25fedf.svg";